/*
 * Copyright (c) 2020, Matthew T. Kaufman
 */

import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)


export const store = new Vuex.Store({
    state: {
        date: ''
    },
    mutations: {
        setDate(state, newDate)
        {
            state.date = newDate;
        }
    },
    actions: {
        setDateAction ({commit}, payload) {
            commit('setDate', payload)
        }
    },
    getters: {
        date(state)
        {
            return state.date;
        }
    }
})